<template>
  <div class="manager_dashboard">
    <user-menu />
    <div class="wrapper">
      <EnterprieSidebarMenu :show_menu="true" :show_back_button="false" back_link="managerReports"></EnterprieSidebarMenu>
      <div class="content-wrapper padding-left-165">
        <div class="container-wrapper center">

          <div class="row">
            <div class="col-12 p-0 pl-2 pr-5">
              <div class="col-9 pl-2 float-left">
                <h3 class="heading text-uppercase mb-3">{{ accountItems.account_name }}</h3>
              </div>
              
              <button v-if="aiSummaryFlag == 1" type="button" class="mm-ask-trigger" @click="openAskModal()">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-compass h-3.5 w-3.5" aria-hidden="true" data-replit-metadata="artifacts/analytics-dashboard/src/components/AskPanel.tsx:335:14" data-component-name="Icon" style="color: rgb(0, 172, 238);"><path d="m16.24 7.76-1.804 5.411a2 2 0 0 1-1.265 1.265L7.76 16.24l1.804-5.411a2 2 0 0 1 1.265-1.265z"></path><circle cx="12" cy="12" r="10"></circle></svg>
                <span class="mm-ask-trigger-label">Ask</span>
              </button>
            </div>
            <div style="clear: both;"></div>
            <div class="col-12 pr-5" v-if="aiSummaryFlag == 1">
              <PlatformSummary
              :role="role"
              ref="PlatformSummary"
              />
            </div>
            <div class="col-6 pr-3 pr-xl-5">


              <div class="row justify-content-between custom-pl-15 pb-4" v-if="menteeCountLoading == true">
                <div class="col pl-0 pr-2" >
                  <PuSkeleton height="150px" :count="1"></PuSkeleton>
                </div>
                <div class="col pl-4" >
                  <PuSkeleton height="150px" :count="1"></PuSkeleton>
                </div>
                <div class="col pl-4 pr-1" >
                  <PuSkeleton height="150px" :count="1"></PuSkeleton>
                </div>
              </div>




              <div class="row justify-content-between custom-pl-15 mb-3" v-if="menteeCountLoading == false">
                <div class="col pl-0 pr-xl-4 pr-lg-2 cursor-pointer" @click="goToLocation()">
                  <div class="shadow p-3 information_box">
                    <div class="information_box_title">Locations</div>
                    <div class="h3">{{ accountItems.totalMappedAccounts }}</div>

                    <span v-if="((accountItems.previousYearAccountCount > 0) && (accountItems.previousYearAccountCount < accountItems.currentYearAccountCount))" class="small px-2 py-1 information_box_text_up">
                      <img class="mr-1 stats_icon" src="@/assets/manager/up_tick_icon.png" />
                      Up {{ parseInt(accountItems.currentYearAccountCount - accountItems.previousYearAccountCount)}} this year</span>
                    <span v-else-if="((accountItems.previousYearAccountCount > 0) && (accountItems.previousYearAccountCount > accountItems.currentYearAccountCount))" class="small px-2 py-1 information_box_text_down">
                      <img class="mr-1 stats_icon" src="@/assets/manager/down_tick_icon.png" />
                      Down {{ parseInt(accountItems.previousYearAccountCount - accountItems.currentYearAccountCount)}} this year</span>
                    <span v-else class="small px-2 py-1">&nbsp;</span>
                    
                  </div>                  
                </div>
                <div class="col px-xl-4 px-lg-2 cursor-pointer" @click="goToMenteeLists()">
                  <div class="shadow p-3 information_box">
                    <div class="information_box_title">Mentees</div>
                    <div class="h3">{{ accountItems.totalMenteesCount }}</div>

                    <span v-if="((accountItems.previousYearMenteeCount > 0) && (accountItems.previousYearMenteeCount < accountItems.currentYearMenteeCount))" class="small px-2 py-1 information_box_text_up">
                      <img class="mr-1 stats_icon" src="@/assets/manager/up_tick_icon.png" />
                      Up {{ parseInt(accountItems.currentYearMenteeCount - accountItems.previousYearMenteeCount)}} this year</span>
                    <span v-else-if="((accountItems.previousYearMenteeCount > 0) && (accountItems.previousYearMenteeCount > accountItems.currentYearMenteeCount))" class="small px-2 py-1 information_box_text_down">
                      <img class="mr-1 stats_icon" src="@/assets/manager/down_tick_icon.png" />
                      Down {{ parseInt(accountItems.previousYearMenteeCount - accountItems.currentYearMenteeCount)}} this year</span>
                    <span v-else class="small px-2 py-1">&nbsp;</span>

                  </div>                  
                </div>
                <div class="col pl-xl-4 pl-lg-2 pr-0 cursor-pointer"  @click="goToCompetencyReport()">
                  <div class="shadow p-3 information_box">
                    <div class="information_box_title">Competencies</div>
                    <div class="h3">{{ accountItems.currentWeekCompetencyCount }}</div>

                    <span v-if="(accountItems.previousWeekCompetencyCount < accountItems.currentWeekCompetencyCount)" class="small px-2 py-1 information_box_text_up">
                      <img class="mr-1 stats_icon" src="@/assets/manager/up_tick_icon.png" />
                      Up {{ parseInt(accountItems.currentWeekCompetencyCount - accountItems.previousWeekCompetencyCount)}} this week</span>
                    <span v-else-if="(accountItems.previousWeekCompetencyCount > accountItems.currentWeekCompetencyCount)" class="small px-2 py-1 information_box_text_down">
                      <img class="mr-1 stats_icon" src="@/assets/manager/down_tick_icon.png" />
                      Down {{ parseInt(accountItems.previousWeekCompetencyCount - accountItems.currentWeekCompetencyCount)}} this week</span>
                    <span v-else class="small px-2 py-1">&nbsp;</span>

                  </div>                  
                </div>
              </div>


              <div class="row">
                <div class="col-12 pr-0 mt-4">


                  <div class="shadow rounded" v-if="graphDisplay == false">

                    <div class="row align-items-end" v-if="competencyGraghLoading == true">
                      <div class="col-5 pl-4">
                        <PuSkeleton height="25px" :count="1"></PuSkeleton>
                      </div>
                      <div class="col-4">
                        <PuSkeleton height="25px" :count="1"></PuSkeleton>
                      </div>
                      <div class="col-3 pr-4">
                        <PuSkeleton height="25px" :count="1"></PuSkeleton>
                      </div>
                    </div>
                    <div class="row mt-5" v-if="competencyGraghLoading == true">
                      <div class="col-11 pr-2 pl-4">
                        <div class="comp_chart_container">
                          <PuSkeleton height="300px" :count="1"></PuSkeleton>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex flex-row bd-highlight pt-3 pr-2" v-if="competencyGraghLoading == false">
                      <div class="col-5 pr-0 h5 d-inline mr-2 font-weight-bold text-uppercase">Earned Competencies</div>
                      <div class="col-4 ea-filter-dropdown text-align-right float-left">
                        <select class="custom-select custom-select-sm" v-model="select_earned_location" @change="onChangeLocationEarnedCompetencies($event);">
                          <option value="">All Locations</option>
                          <option v-for="(item, index) in report_all_locations" :key="index" :value="item.id">{{ item.company_name }}</option>
                        </select>
                      </div>

                      <div class="col-3 pr-2 ea-filter-dropdown text-align-right float-right pl-0">
                        <select class="custom-select custom-select-sm" @change="onChangeMonthEarnedCompetencies($event);">
                          <option value="6">6 Months</option>
                          <option value="9">9 Months</option>
                          <option value="12">12 Months</option>
                        </select>
                      </div>
                    </div>
                    <div class="mychart" id="myChartDiv2" v-if="competencyGraghLoading == false">
                      <canvas id="myChart2" width="400" :height="height" ></canvas>
                    </div>
                  </div>

                  <div class="shadow rounded" v-if="menteeCountLoading == false && graphDisplay == true" style="height: 350px; overflow-y: scroll;">
                    <LocationProgressChart
                      :locationNames="barChartCategories"
                      :seriesValues="barChartSeries"
                      :locations="locationsLists"
                      seriesName="Mentee Progress"
                      ref="LocationProgressChart"
                    />
                  </div>
                </div>
              </div>



              <!-- competency & reports box start -->
              <div class="row ea-row mt-5">
                <div class="col-12 pr-0">
                  <div class="shadow rounded pr-2 pl-3 py-1 min-height-330">
                    <div class="d-flex flex-row bd-highlight pt-3" v-if="comp_loading == false">
                      <div class="col-9 h5 d-inline mr-2 pl-0 font-weight-bold text-uppercase">Competency Comparison</div>
                      <div class="col-3 pr-2 ea-filter-dropdown">
                        <select class="custom-select custom-select-sm" @change="getCompetencyComparison" v-model="competency_comparison">
                          <option value="60">60 Days</option>
                          <option value="90">90 Days</option>
                          <option value="180">6 Months</option>
                          <option value="365">1 Year</option>
                        </select>
                      </div>
                    </div>
                    <div class="">
                      <div class="row mt-3" v-if="comp_loading == false">
                      <div class="col-1">#</div>
                      <div class="col-5">Location</div>
                      <div class="col-3 text-center">Reps Recorded</div>
                      <div class="col-3 text-center">Competencies Earned</div>
                      </div>
                      <div class="clearfix"></div>


                    <div class="text-center pt-4" v-if="comp_loading == true">
                      <div class="row" v-for="option in 5">
                        <div class="col-1"><PuSkeleton :count="1"></PuSkeleton></div>
                        <div class="col-5 padding-l-10"><PuSkeleton :count="1"></PuSkeleton></div>
                        <div class="col-3 padding-l-10"><PuSkeleton :count="1"></PuSkeleton></div>
                        <div class="col-3 padding-l-10"><PuSkeleton :count="1"></PuSkeleton></div>
                        <div class="col-12 p-0">
                          <div class="custom_hr"></div>
                        </div>
                      </div>
                    </div>

                      <div v-if="competencyComparisonCount > 0" class="col-12 p-0 mt-4">
                        <div class="row" v-for="(item, index) in accountItems.competencyComparison" :key="index">
                          <div v-if="index == 0 && (item.reps_recorded > 0 || item.competencies_earned > 0) && !isReadOnly" class="col-1 pl-0">
                            <img src="@/assets/enterprise/Required_Gold_Batch_image_45X45.png" />
                          </div>
                          <div v-else class="col-1">{{ (index+1) }}</div>
                          <div class="col-5"><a @click="openSidebar(item.id)" class="ea-quick-link cursor-pointer font-color-00acee" > {{ item.org_name }} </a></div>
                          <div class="col-3  text-center">{{ item.reps_recorded }}</div>
                          <div class="col-3 text-center">{{ item.competencies_earned }}</div>
                          <div class="clearfix"></div>
                        </div>
                      </div>
                      <div v-else class="text-red text-center m-4">{{ getNoRecordText(competencyComparisonCount) }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- competency & reports box end -->









            </div>



            <div class="col-6 pl-4 pl-xl-4 pr-3 pr-xl-5 mb-5">              


            <div class="col-12 mb-3 p-0" >
              <div class="shadow rounded px-2 py-1">
                <div class="information_box_title pt-2 mt-1 mb-0 pl-2">Quick Access</div>

                <div class="row justify-content-center mb-2">


                  <router-link :to="{ name: 'locations' }" class="text-muted">
                  <div class="report-panel rounded text-center p-1 text-muted">
                      <img class="report-icon1 " height="25px" width="14px" src="@/assets/manager/Enterprise_Quick_Access_Locations_Icons.png" />
                      <p class="mb-0 small font-color-002f42">Locations</p>
                  </div>
                  </router-link>

                  <router-link to="/enterprise-admin/competency-report-overview/All" class="text-muted">
                  <div class="report-panel rounded text-center p-1 text-muted" >
                      <img class="report-icon report-badge" src="@/assets/manager/competency_report_icon.png" />
                      <p class="mb-0 small font-color-002f42">Competency</p>
                  </div>
                  </router-link>

                  <router-link :to="{ name: 'enterpriseadminusagereport' }" class="text-muted">
                  <div class="report-panel rounded text-center p-1 text-muted mr-0">
                      <img class="report-icon" src="@/assets/manager/usage_report_icon.png" />
                      <p class="mb-0 small font-color-002f42">Usage</p>

                  </div>
                  </router-link>

                  <router-link :to="{ name: 'EnterprisePathwayProgressPathwayLists' }" class="text-muted">
                  <div class="report-panel rounded text-center p-1 text-muted">
                      <img class="report-icon" src="@/assets/manager/Mentor Mentee Progress Report Icon.png"  />
                      <p class="mb-0 small font-color-002f42">Progress</p>
                  </div>
                  </router-link>



                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12 mt-4">



                <div class="shadow rounded" v-if="graphDisplay == false">
                  <div class="row align-items-end" v-if="repsGraghLoading == true">
                    <div class="col-5 pl-4">
                      <PuSkeleton height="25px" :count="1"></PuSkeleton>
                    </div>
                    <div class="col-4">
                      <PuSkeleton height="25px" :count="1"></PuSkeleton>
                    </div>
                    <div class="col-3 pr-4">
                      <PuSkeleton height="25px" :count="1"></PuSkeleton>
                    </div>
                  </div>
                  <div class="row mt-5" v-if="repsGraghLoading == true">
                    <div class="col-11 pr-2 pl-4">
                      <div class="comp_chart_container">
                        <PuSkeleton height="300px" :count="1"></PuSkeleton>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex flex-row bd-highlight pt-3 pr-2" v-if="repsGraghLoading == false">
                    <div class="col-5 pr-0 h5 d-inline mr-2 font-weight-bold text-uppercase">Activity Over Time</div>
                    <div class="col-4 ea-filter-dropdown text-align-right float-left">
                      <select class="custom-select custom-select-sm" v-model="select_activity_location" @change="onChangeLocationActivityOverTime($event);">
                        <option value="">All Locations</option>
                        <option v-for="(item, index) in report_all_locations" :key="index" :value="item.id">{{ item.company_name }}</option>
                      </select>
                    </div>
                    <div class="col-3 pr-2 ea-filter-dropdown text-align-right float-right pl-0">
                      <select class="custom-select custom-select-sm" @change="onChangeMonthActivityOverTime($event);">
                        <option value="6">6 Months</option>
                        <option value="9">9 Months</option>
                        <option value="12">12 Months</option>
                      </select>
                    </div>

                  </div>
                  <div class="mychart" id="myChartDiv" v-if="repsGraghLoading == false">
                    <canvas id="myChart" width="400" :height="height" ></canvas>
                  </div>
                </div>

                <div class="shadow rounded" v-if="menteeCountLoading == false && graphDisplay == true" style="height: 350px; overflow-y: scroll;">
                  <MenteeReviewStatusChart
                    :totalMentorReviewCount="totalMentorReviewCount"
                    :totalMentorReviewedCount="totalMentorReviewedCount"
                    :mentorReviewList="mentorReviewList"
                    :barchartMentorReviewCategories="barchartMentorReviewCategories"
                    :barchartMentorReviewSeries="barchartMentorReviewSeries"
                    :barchartMentorReviewedSeries="barchartMentorReviewedSeries"
                    :maxValue="maxValue"
                    :tickAmount="tickAmount"
                    :locationDataMentorReview="locationDataMentorReview"
                    seriesName="Mentee Progress"
                    ref="MenteeReviewStatusChart"
                  />
                  
                </div>
              </div>
            </div>

            <div class="col-12 p-0 notification-wrapper">
              <DashboardNotifications></DashboardNotifications>
            </div>


            </div>
          </div>
        </div>
      </div>
    </div>


    <EnterpriseAdminOverlaySidebar
      :isModalVisible="isModalVisible" 
      @close="closeSidebar"
      ref="location_sidebar" 
      :readOnly="isReadOnly" 
      />

    <EndUserLicenseAgreementModal
      :isModalVisible="isEndUserLicenseAgreementModalVisible" 
      @close="closeEndUserLicenseModal"
      ref="end_user_license_agreement"               
       />

    <AskPanel  
      :role="role" 
      :isModalVisible="isAskModalVisible"
      :location="locationsLists"
      ref="AskPanel"
      @close="closeAskModal"
      @action="onAskAction"
       />

  </div>  
</template>

<script>
  import Vue from 'vue/dist/vue.esm';
  import UserMenu from '../shared/user_menu.vue';
  import axios from 'axios';
  import router from '../../router/index.js';
  import store from '../../store/store.js';
  import Chart from 'chart.js';
  import DashboardNotifications from '@/components/manager/dashboard_notifications.vue';
  import EnterprieSidebarMenu from '@/components/shared/enterpriseadmin_sidebar_menu.vue';
  import EnterpriseAdminOverlaySidebar from './enterpriseadmin_overlay_sidebar.vue';
  import EndUserLicenseAgreementModal from '@/components/shared/end_user_license_agreement_modal.vue';
  import LocationProgressChart from '@/components/enterpriseadmin/location_progress_chart.vue';
  import MenteeReviewStatusChart from '@/components/enterpriseadmin/mentee_review_status_chart.vue';
  import AskPanel from '@/components/manager/ask_panel_modal.vue';
  import PlatformSummary from '@/components/manager/PlatformSummary.vue';


export default {
  data() {
    return {
      comp_loading: false,
      isModalVisible: false,
      accountItems: { 
        account_name: '',
        totalMappedAccounts: 0,
        previousYearAccountCount: 0,
        currentYearAccountCount: 0,
        totalMenteesCount: 0,
        previousYearMenteeCount: 0,
        currentYearMenteeCount: 0,
        totalCompetenciesCount: 0,
        previousWeekCompetencyCount: 0,
        currentWeekCompetencyCount: 0,
        competencyComparison: [],
        activityBarValues: [],
        activityBarLabels: [],
        activityBarMaxValues: '',
        activityBarStepSize: '',
        earnedBarValues: [],
        earnedBarLabels: [],
        earnedBarMaxValues: '',
        earnedBarStepSize: '',
      },
      height: 300,
      competency_comparison: 60,
      earned_month_limit: 6,
      activity_month_limit:6,
      select_earned_location: '',
      select_activity_location: '',
      select_report_location: '',
      report_all_locations: [],
      competencyComparisonCount: 0,
      isEndUserLicenseAgreementModalVisible: false,
      competencyGraghLoading: false,
      repsGraghLoading: false,
      barChartCategories: [],
      barChartSeries: [],
      locationsLists: [],
      totalMentorReviewCount: 0,
      totalMentorReviewedCount: 0,
      mentorReviewList: [],
      barchartMentorReviewCategories: [],
      barchartMentorReviewSeries: [],
      barchartMentorReviewedSeries: [],
      maxValue: '',
      tickAmount: '',
      locationDataMentorReview: [],
      isAskModalVisible: false,
      role: 'enterprise_admin',
      aiSummaryFlag: 0,
    }    
  },
  computed: {
    isReadOnly(){
      if (this.$store.state.enterprise_type === 'Readonly') {
        return true;
      } else {
        if (this.$store.state.switch_admin_enterprise_isreadonly) {
          return true;
        } else {
          return false;
        }
      }
    }
  },

  components: {
    UserMenu,
    DashboardNotifications,
    EnterprieSidebarMenu,
    EnterpriseAdminOverlaySidebar,
    EndUserLicenseAgreementModal,
    LocationProgressChart,
    MenteeReviewStatusChart,
    AskPanel,
    PlatformSummary,
  },
  methods: {
    openAskModal() {
      this.isAskModalVisible = true;
      this.$refs.AskPanel.loadInitialData();
    },
    closeAskModal() {
      this.isAskModalVisible = false;
    },
    onAskAction(action) {
      const eventName = action && action.event ? action.event : '';
      if (eventName === 'open-review-queue' || eventName === 'open-reps-to-review') {
        this.closeAskModal();
        this.openAccountRepToReviewModal();
      }
    },
    closeEndUserLicenseModal() {
      this.isEndUserLicenseAgreementModalVisible = false;
    },
    openSidebar(accountId) {
      this.isModalVisible = true;
      this.$refs.location_sidebar.getLocationDetail(accountId);
    },
    closeSidebar() {
      this.isModalVisible = false;
      this.$refs.location_sidebar.selectedComponent = 'OverviewTab';
    },
    goToCompetencyReport() {
      router.push('/enterprise-admin/competency-report-overview/All?dhb=1')
    },
    goToLocation() {
      router.push('/locations')
    },
    goToMenteeLists() {
      router.push('/users/mentees')
    },
    getNoRecordText(count) {
        if (this.loading) {
            return '';
        } else {
            if (count == 0 && this.isRepsReceived) {
                return 'No Location found with Reps Recorded';
            }
        }
    },
    getCompetencyComparison(){
      var days_limit = this.competency_comparison;
      this.comp_loading = true;
      this.accountItems.competencyComparison = [];
      this.competencyComparisonCount = 0;
      this.isRepsReceived = false;
      axios('/enterprise-admin/get-competency-comparison',
        {
          method: 'GET',
          params: {
            account_id: this.accountItems.id,
            days: days_limit,
          }
        })
        .then(resp => {
          this.comp_loading = false;
          this.accountItems.competencyComparison = resp.data;
          this.competencyComparisonCount = resp.data.length;
          this.isRepsReceived = true;
      })
        .catch(() => {
      });
    },
    onChangeLocationEarnedCompetencies(event) {
      this.select_earned_location = event.target.value;
      this.getEarnedCompetencies();
    },
    onChangeLocationActivityOverTime(event) {
      this.select_activity_location = event.target.value;
      this.getActivityOverTime();
    },
    onChangeMonthActivityOverTime(event) {
      this.activity_month_limit = event.target.value;
      this.getActivityOverTime();
    },
    onChangeMonthEarnedCompetencies(event) {
      this.earned_month_limit = event.target.value;
      this.getEarnedCompetencies();
    },
    getActivityOverTime() {
      this.repsGraghLoading = true;
      axios('/enterprise-admin/get-activity-over-time',
        {
          method: 'GET',
          params: {
            account_id: this.accountItems.id,
            month: this.activity_month_limit,
            location: this.select_activity_location,
          }
        })
        .then(resp => {
          this.accountItems.activityBarValues = resp.data.activityBarValues;
          this.accountItems.activityBarLabels = resp.data.activityBarLabels;
          this.accountItems.activityBarMaxValues = resp.data.activityBarMaxValues;
          this.accountItems.activityBarStepSize = resp.data.activityBarStepSize;
          this.initActivityOverTimeGraph();
        })
        .catch(() => {
        });
    },




    getEarnedCompetencies() {
      this.competencyGraghLoading = true;
      axios('/enterprise-admin/get-earned-competencies',
        {
          method: 'GET',
          params: {
            account_id: this.accountItems.id,
            month: this.earned_month_limit,
            location: this.select_earned_location,
          }
        })
        .then(resp => {
          this.accountItems.earnedBarValues = resp.data.earnedBarValues;
          this.accountItems.earnedBarLabels = resp.data.earnedBarLabels;
          this.accountItems.earnedBarMaxValues = resp.data.earnedBarMaxValues;
          this.accountItems.earnedBarStepSize = resp.data.earnedBarStepSize;
          this.initEarnedCompetenciesGraph();
        })
        .catch(() => {
        });
    },
    initActivityOverTimeGraph() {
      this.repsGraghLoading = false;
      setTimeout(() => {
      var ctx = document.getElementById('myChart');
      const data = {
        labels: this.accountItems.activityBarLabels,
        datasets: [{
          label: '',
          data: this.accountItems.activityBarValues,
          fill: false,
          borderColor: 'rgb(0, 172, 238)',
          backgroundColor: 'rgb(255, 255, 255)',
          tension: 0.1,
          borderWidth: 3,
          borderRadius: 5,
          pointBorderWidth: 2,
          borderSkipped: false,
        }]
      };
      var myChart = new Chart(ctx, {
        type: 'line',
        data: data,
        options: {
          indexAxis: 'y',
          elements: {
            bar: {
              borderWidth: 1,
            }
          },
          title: {
              display: false,
          },
          layout: {
            padding: {
              left: 0,
              right: 60,
              top: 15,
              bottom: 0
            }
          },
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          events: [],
          scales: {
            xAxes: [{
                gridLines: {
                  drawOnChartArea:false,
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Months'
                }
            }],
            yAxes: [{
              ticks: {
                  beginAtZero: true,
                  max: this.accountItems.activityBarMaxValues,
                  min: 0,
                  stepSize: this.accountItems.activityBarStepSize,
                  callback: function(value,   index, values) {
                    return value;
                  },
              },
              barThickness: 1,
              categoryPercentage: 1.0,
              gridLines: {
                drawOnChartArea:false,
              },
              stacked: true,
              scaleLabel: {
                display: true,
                labelString: 'Reps'
              }
            }],
          },
        }
      });
      }, 1000);
    },
    initEarnedCompetenciesGraph() {
      this.competencyGraghLoading = false;
      setTimeout(() => {
      var ctx2 = document.getElementById('myChart2');
      const data2 = {
        labels: this.accountItems.earnedBarLabels,
        datasets: [{
          label: '',
          data: this.accountItems.earnedBarValues,
          fill: false,
          borderColor: 'rgb(0, 172, 238)',
          backgroundColor: 'rgb(255, 255, 255)',
          tension: 0.1,
          borderWidth: 3,
          borderRadius: 5,
          pointBorderWidth: 2,
          borderSkipped: false,
        }]
      };

      var myChart = new Chart(ctx2, {
        type: 'line',
        data: data2,
        options: {
          indexAxis: 'y',
          elements: {
            bar: {
              borderWidth: 1,
            }
          },
          title: {
              display: false,
          },
          layout: {
            padding: {
              left: 0,
              right: 60,
              top: 15,
              bottom: 0
            }
          },
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          events: [],
          scales: {
            xAxes: [{
              scaleLabel: {
                display: true,
                labelString: 'Months'
              },
              gridLines: {
                drawOnChartArea:false,
              }
            }],
            yAxes: [{
                ticks: {
                    beginAtZero: true,
                    max: this.accountItems.earnedBarMaxValues,
                    min: 0,
                    stepSize: this.accountItems.earnedBarStepSize,
                    callback: function(value,   index, values) {
                      return value;
                    },
                },
                gridLines: {
                  drawOnChartArea:false,
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Reps'
                },
            }],
          },
        }
      });
      }, 1000);
    },

  },

  created() {
    this.menteeCountLoading = true;
    this.competencyGraghLoading = true;
    this.repsGraghLoading = true;
    axios.get('/get-account-ai-summary-flag', {
      params: {
        accountId: this.$store.state.user_accountid,
      }
    })
    .then(response =>  {
      this.aiSummaryFlag = response.data;
    })
    .catch(function() {});
    axios('/enterprise-admin-info',
    {
        method: 'GET',
    })
    .then(resp => {
      this.menteeCountLoading = false;
      this.accountItems = resp.data.account;
      this.graphDisplay = resp.data.account.graphDisplay;
      var licenseflag = this.accountItems.eulaFlag;
      this.barChartCategories = this.accountItems.locationResponse.barchartCategories;
      this.totalMentorReviewCount = this.accountItems.locationResponse.totalMentorReviewCount;
      this.totalMentorReviewedCount = this.accountItems.locationResponse.totalMentorReviewedCount;
      this.mentorReviewList = this.accountItems.locationResponse.mentorReviewList;
      this.barchartMentorReviewCategories = this.accountItems.locationResponse.barchartMentorReviewCategories;
      this.barchartMentorReviewSeries = this.accountItems.locationResponse.barchartMentorReviewSeries;
      this.barchartMentorReviewedSeries = this.accountItems.locationResponse.barchartMentorReviewedSeries;
      this.barChartSeries = this.accountItems.locationResponse.barchartSeries;
      this.locationsLists = this.accountItems.locationResponse.list;
      this.maxValue = this.accountItems.locationResponse.maxValue;
      this.tickAmount = this.accountItems.locationResponse.tickAmount;
      this.locationDataMentorReview = this.accountItems.locationResponse.locationDataMentorReview;
      if(licenseflag == 0) {
        this.isEndUserLicenseAgreementModalVisible = true;
      }
      this.defaultLocationId = this.accountItems.id;
      if (this.accountItems.length == 0) {
        this.isRepsReceived = true;
      }
      setTimeout(() => {
        if (this.graphDisplay == false) {
          this.initActivityOverTimeGraph();
          this.initEarnedCompetenciesGraph();
        }
        this.getCompetencyComparison();
      }, 3000);
    })
    .catch(() => {
    });

    axios('/enterprise-admin/getAllLinkedLocations',
    {
        method: 'GET'
    })
    .then(response => {
        this.loading = false;
        this.report_all_locations = response.data.locations;
        if (this.report_all_locations.length > 0) {
          this.select_report_location = this.report_all_locations[0].id;
        }
    })
    .catch(() => {
    });


  },

}

</script>

<style>
@import '../../assets/styles/style_v2.css';
</style>

<style scoped>
.information_box_title {
  font-size: 1.25rem !important;
}
@media (max-width: 1199.98px) {
  .information_box_title {
    font-size: 1rem !important;
  }
}
.fixed-bell-icon {
    position: fixed;
    right: 15px;
    bottom: 30px;
    border-radius: 50%;
    box-shadow: 1px 1px 11px 1px #a59a9a;
    font-size:25px;
    background-color: #29A3E4 !important;
    border-color: #29A3E4 !important; 
    cursor: pointer;
}
.content-wrapper {
  padding-top: 75px;
}
.container-wrapper .heading {
  font-size: 28px;
  font-weight: normal;
}
.information_box_text_up {
  border-radius: 5px;
  background-color: #D8F2FC;
}

.information_box_text_up i {
  color: #4DB1D8;
  transform: rotate(45deg);
}
.information_box_text_down {
  border-radius: 5px;
  background-color: #FBD9CC;

}
.information_box_text_down i {
  color: #F16733;
  transform: rotate(315deg);
}

@media (max-width: 1199.98px) {
  .information_box_text_up, .information_box_text_down {
    font-size: .65rem !important;
  }
}
input:focus, select:focus, textarea:focus, button:focus {
  border-color: #ced4da;
}
a {
  color: #00acee;
}
a:hover,
a:active,
a:focus {
  color: #00acee;
}
.modal-header .sub-heading h3 {
  color: #002F42;
  font-size: 15px;
  font-weight: 900;
}
.ma-blue-btn {
  color: #FFF !important; 
  border-radius: 10px;
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  font-weight: 900;
  width: 130px;
  padding: 4px;
}
.stats_icon {
  width: 8px !important;
}
@media (max-width: 1366px) {
  .report-panel {
    width: 95px;
    border-color: #002F42 !important;
  }
}
@media (min-width: 1367px) {
  .report-panel {
    width: 112px;
    border-color: #002F42 !important;
  }
}
select {
  height: 28px;
  padding: 0 0.5rem;
}
.custom_heading_hr,
.custom_hr {
    width: 100%;
    margin: 5px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.report-icon {
  width: 25px; margin-top: 5px; margin-bottom: 10px;  
}
.report-icon1 {
  width: 16px; margin-top: 5px; margin-bottom: 10px;  
}
.mychart {
  width: 100%; margin: 0 0.8rem;
}
.min-height-330 {
  min-height: 330px;
}
.report-badge {
  width: 19px !important;
}
.notification-wrapper {
  padding-top: 40px !important;
}
.mm-ask-trigger {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  padding: 0 14px;
  border-radius: 8px;
  border: 1px solid #e4e9ec;
  background-color: rgba(0, 172, 238, 0.12);
  color: rgb(0, 144, 201);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
  float: right;
}
.mm-ask-trigger:hover {
  background-color: rgba(0, 172, 238, 0.12);
  border: 1px solid #e4e9ec;
}
.mm-ask-trigger-icon {
  color: #00acee;
}
.mm-ask-trigger-label {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/enterpriseadmin/enterprise_admin_dashboard.vue